import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Navbar';
import Home from './Pages/Home';
import Team from './Pages/Team';
import Services from './Pages/Services';
import {Contact} from './Pages/Contact';
import Calculator from './Pages/Calculator';
import Form from './Pages/Form';

function App() {
  return (
    <>
      <div className="App">
        <Router>
        <Navbar />
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/services' element={<Services/>}/>
          <Route path='/meet-the-team' element={<Team/>}/>
          <Route path='/contact' element={<Contact/>}/>
          <Route path='/calculator' element={<Calculator/>}/>
          <Route path='/form' element={<Form/>}/>
        </Routes>
        </Router>
      </div>
    </>
    
  );
}

export default App;
